module.exports = __webpack_public_path__ + "static/media/nonfood.bb2b1cea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/assortiment/nonfood.jpg
// module id = 893
// module chunks = 0